import { FinancialReviewFormCreate } from 'features/FinancialReview/pages';
import Layout from 'layout';
import { Can } from 'components/Can';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function FinancialReviewFormCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        <Can do="create" on="financial_review">
          <FinancialReviewFormCreate />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}
